"use strict";

require("../../style/default.less");
require("./index.less");
require("../../button/style");
require("../../checkbox/style");
require("../../dropdown/style");
require("../../empty/style");
require("../../input/style");
require("../../pagination/style");
require("../../radio/style");
require("../../spin/style");
require("../../tooltip/style");
require("../../tree/style");